import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class GatewayAvailabilityService {
    static checkAvailabilityBasedOnAddress(availabilityRequestDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayavailability'),
            'isProductAvailableBasedOnAddress',
            [availabilityRequestDTO],
            additionalHeaders
        );
    }
}
